import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminRoute } from "./components/AdminRoute";
import NewHome from "./pages/NewHome";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Browse from "./pages/Browse";
import Live from "./pages/Live";
import Watch from "./pages/Watch";
import Dashboard from "./pages/Dashboard";
import Subscription from "./pages/Subscription";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Competitions from "./pages/Competitions";
import CompetitionDetail from "./pages/CompetitionDetail";
import TeamProfile from "./pages/TeamProfile";
import Following from "./pages/Following";
import Highlights from "./pages/Highlights";
import MatchCenter from "./pages/MatchCenter";
import MatchDay from "./pages/MatchDay";
import MatchCalendar from "./pages/MatchCalendar";
import MatchFeed from "./pages/MatchFeed";
import AdminMetrics from "./pages/AdminMetrics";
import About from "./pages/About";
import Originals from "./pages/Originals";

function AppRouter() {
  const location = useLocation();

  // Lightweight page view tracking for retention metrics
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const API = process.env.REACT_APP_BACKEND_URL;
    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ event_type: 'page_view', page: location.pathname }),
    }).catch(() => {});
  }, [location.pathname]);
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<NewHome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/competitions" element={<Competitions />} />
      <Route path="/competitions/:slug" element={<CompetitionDetail />} />
      <Route path="/team/:teamSlug" element={<TeamProfile />} />
      <Route path="/following" element={<ProtectedRoute><Following /></ProtectedRoute>} />
      <Route path="/highlights" element={<Highlights />} />
      <Route path="/live" element={<Live />} />
      <Route path="/match/:id" element={<MatchCenter />} />
      <Route path="/matchday/:matchId" element={<MatchDay />} />
      <Route path="/calendar" element={<MatchCalendar />} />
      <Route path="/feed" element={<MatchFeed />} />
      <Route path="/watch/:id" element={<Watch />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
      <Route path="/admin/metrics" element={<AdminRoute><AdminMetrics /></AdminRoute>} />
      <Route path="/about" element={<About />} />
      <Route path="/originals" element={<Originals />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
